import React, { JSX } from 'react'
import './index.scss'
import { RowComponent } from './RowComponent'

export type JourneyProps = {
  content: any
}

/**
 * Journey component for displaying a sequence of milestones.
 *
 * @remarks
 * Renders a visual journey with a start indicator and a list of milestones using the RowComponent.
 * Each milestone can include description, color, label, alignment, icon, and image.
 *
 * @param props - The properties for the Journey component.
 * @param props.content - The content data containing milestone information.
 * @returns The rendered Journey component.
 */
export const Journey = ({ content }: JourneyProps): JSX.Element => {
  return (
    <div className='JourneysComponent u-sizeConstrained u-md-paddingHoriz40'>
      <div className='Journey u-flex u-paddingBottom40 u-posRelative u-sizeFull u-lg-size6of12 u-lg-before6of12'>
        <i className='Journey-step-start u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull'></i>
      </div>
      {content.milestone.milestones.map((item: any) => (
        <RowComponent
          contentDesc={item.textContent}
          milestoneColor={item.bgcolor}
          milestoneMonthDesc={item.label}
          key={item.label}
          leftAligned={item.alignment === 'Left Aligned'}
          icon={item.icon}
          image={item.image}
        />
      ))}
    </div>
  )
}
